import { useState } from "react";
import moment from "moment";
import RegistrationFeeSubmission from "./RegistrationFeeSubmission";

const AnnualTaxSubmission = () => {
  const [year, setYear] = useState(moment().year());

  const getYears = () => {
    let current_year = moment().add(1, "y").format("yyyy");
    let start_year = 2000;

    const options = [];

    while (current_year >= start_year) {
      options.push(current_year);
      current_year -= 1;
    }

    return options;
  };

  const handleYearChange = (e) => {
    const selected_year = e.target.value;
    setYear(selected_year);
  };

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between">
        <p className="text-gray-500">
          Tax Submission <span className="text-gray-400">— Annual</span>
        </p>
        <div className="flex items-center text-gray-400 text-sm">
          <p className="mr-4">Year:</p>
          <select
            className="form-control"
            value={year}
            onChange={handleYearChange}
          >
            {getYears().map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6 py-5">
        <div className="col-span-2">
          <RegistrationFeeSubmission year={year} />
        </div>
      </div>
    </div>
  );
};

export default AnnualTaxSubmission;
